/**
 * Side scroller component
 * 
 * @description
 * <p>Sets up and manages horizontal scroll areas</p>
 * <p>On page load, sets up side scroller for elements with sideScroller class; adds left/right arrows if content overflows; sets up handlers for resize, click and swipe events to reposition or scroll the content as appropriate</p>
 * <p>Self-initializes when you include this module</p>
 * 
 * @module sidescroller
 * 
 */
( /* @lends module:sidescroller */ function(site,$){
	"use strict";
(function($){
	var $window = $(window),
		$dom = {},
		trace = {push: function() {}},
		firstSlide = false,
		allData = 0,
		arrowCounter = 0,
		initialcounter=0,
		selectors = {
			wrap : '.sideScroller',
			holder : '> .holder',
			thumbs : '.thumbs',
			thumb : '.thumb',
			aL: '.arrow-left',
			aR: '.arrow-right'
		},
		$arrowL = $('<button type="button" class="arrow-left hidden hoverable" aria-hidden="true">'
			+ '<i class="fa fa-chevron-left" aria-hidden="true"></i>'
			+ '</button>'
		),
		$arrowR = $('<button type="button" class="arrow-right hoverable" aria-hidden="true">'
			+ '<i class="fa fa-chevron-right" aria-hidden="true"></i>'
			+ '</button>'
		);

	/**
	 * Sidescroller Initializer
	 */
	function init() {

		// register modules/libraries for local use
		trace = site.utilities && site.utilities.trace ? site.utilities.trace : {push: function() {}};
		
		// cache DOM elements
		$dom.scroller = $(selectors.wrap);
		if(!$dom.scroller.length){
			return;
		}
		
		checkOverflows();
		
		$window.on('resize', function(){
			checkOverflows();
		});
	}

	/**
	 * Check content size to container size to determine if arrows are needed and add/remove accordingly
	 */
	function checkOverflows(){
		$dom.scroller.each(function(i,$elm){			
			$elm = $($elm);	
			var thumbsW = Math.floor($(selectors.holder,$elm)[0].scrollWidth),
				holderW = Math.floor($(selectors.thumbs,$elm).outerWidth()),
				$aR = $arrowR.clone(),
				$aL = $arrowL.clone();

			if(thumbsW > holderW){
				if(!$elm.find('> button').length) {
					trace.push('adding arrows to ',$elm);
					$elm.append($aR).append($aL);
					setListeners($elm, $aR, $aL);
				}
			}
			else {
				if($elm.find('> button').length) {
					trace.push('removing arrows from ',$elm);
					$elm.find('> button').off('click').remove();
				}
			}
		});
	}

	/**
	 * Set arrow listeners for given sidescroller
	 * @param {object} $elm the sidescroller
	 * @param {object} $aR  the right arrow
	 * @param {object} $aL  the left arrow
	 */
	function setListeners($elm, $aR, $aL) {
		$aL.on('click', function() {
			scrollContent($elm,'left');
		});

		$aR.on('click', function() {
			if(!firstSlide) firstSlide = !firstSlide;
			scrollContent($elm,'right');
		});

		$elm.on('swipeleft', function(){
			scrollContent($elm,'right');
		}).on('swiperight', function(){
			scrollContent($elm,'left');
		});
	}
	$('body.path-values').ready(function(){
		 
		$(".awards .thumbs .thumb").each(function(index){
			//console.log("index="+index);
			 allData++;
		});
		console.log("allData="+allData);
		if(allData >=3 && allData != 4){
			arrowCounter = allData-3;
			initialcounter = arrowCounter;
		}else if(allData == 4){
			arrowCounter = allData-3;
			initialcounter = arrowCounter-1;
			console.log("initialcounterbase="+initialcounter);
		}
		
		$( "body.path-values .awards").addClass("value-left");
		//initialDisplayNumber=allData-3;
	});
	/**
	 * Scroll Content Left/Right 
	 * @param  {string} dir "left" or "right" direction to scroll
	 */
	function scrollContent($elm,dir) {
		var $holder = $(selectors.holder,$elm),
			$thumb = $(selectors.thumb,$holder),
			thumbW = $thumb.width(),
			method = dir == 'left' ? '-=' : '+=';

		var $arrowL = $(selectors.aL,$elm);
		var $arrowR = $(selectors.aR,$elm);
		

		if(firstSlide) $arrowL.removeClass('hidden');

		$holder.animate({ 'scrollLeft': method+thumbW, }, 500, 'swing');

		var breakpoint = site.getBreakPoint();
		trace.push('breakpoint = '+breakpoint);
		if(breakpoint == "bp-large" && $('body.path-values').length) {
			setTimeout(function(){
				toggleArrows_values($holder, $thumb, $arrowL, $arrowR, dir);
			}, 250);	
		}else if(breakpoint == "bp-large"){
			setTimeout(function(){
				toggleArrows($holder, $thumb, $arrowL, $arrowR, dir);
			}, 250);
		}
		

	}

	/**
	 * Toggle opacity and index of left/right arrows 
	 *
	 * @param   {[type]}  $holder  
	 * @param   {[type]}  $thumb   
	 * @param   {[type]}  $arrowL  
	 * @param   {[type]}  $arrowR  
	 * @param   {[type]}  dir      dir "left" or "right"
	 */
	function toggleArrows($holder, $thumb, $arrowL, $arrowR, dir) {
		var windowW = $window.width(),
			holderW = $holder[0].scrollWidth,
			thumbW = $thumb.width(),
			thumbLeft = Math.abs($thumb[0].getBoundingClientRect().left),
			thumbRight = $thumb[$thumb.length -1].getBoundingClientRect().right - thumbW,
			scrollSpace = holderW - (windowW + thumbW),
			thumbLeft_all = $thumb[0].getBoundingClientRect().left;
	
		//if (dir == 'left' && thumbLeft < Math.abs(scrollSpace) ) {
		if (dir == 'left' && thumbLeft < 100) {
			$arrowL.addClass('hide');
		} else {
			$arrowL.removeClass('hide');
		}

		//if(dir == 'right' && (thumbRight + scrollSpace) <= windowW) {
		if(dir == 'right' && (thumbRight) <= windowW) {
			$arrowR.addClass('hide');
		} else {
			$arrowR.removeClass('hide');
		}
		
	}

	/**
	 * Toggle opacity and index of left/right arrows 
	 *
	 * @param   {[type]}  $holder  
	 * @param   {[type]}  $thumb   
	 * @param   {[type]}  $arrowL  
	 * @param   {[type]}  $arrowR  
	 * @param   {[type]}  dir      dir "left" or "right"
	 */
	function toggleArrows_values($holder, $thumb, $arrowL, $arrowR, dir) {
		var windowW = $window.width(),
			holderW = $holder[0].scrollWidth,
			thumbW = $thumb.width(),
			thumbLeft = Math.abs($thumb[0].getBoundingClientRect().left),
			thumbRight = $thumb[$thumb.length -1].getBoundingClientRect().right - thumbW,
			scrollSpace = holderW - (windowW + thumbW),
			thumbLeft_all = $thumb[0].getBoundingClientRect().left;
			
			
		if(allData >=3 && allData != 4){
			if (dir == 'left' && initialcounter != arrowCounter)
			{
				arrowCounter++;
				if(initialcounter == arrowCounter){
					$arrowL.addClass('hide');
					$("body.path-values .awards").addClass("value-left");
				}else{				
					$arrowL.removeClass('hide');
					$arrowR.removeClass('hide');
				}
			}
			if(dir == 'right' && arrowCounter <= allData && arrowCounter!=0 ){
				arrowCounter--;
				$("body.path-values .awards").removeClass("value-left");
				if(arrowCounter == 0){
					$arrowR.addClass('hide');				
				}else{
					$arrowR.removeClass('hide');
					$arrowL.removeClass('hide');
				}
			}
		} else if(allData == 4){
		
			if (dir == 'left')
			{	$arrowL.addClass('hide');
				$("body.path-values .awards").addClass("value-left");
			
			} else{
				$arrowL.removeClass('hide');
				$arrowR.removeClass('hide');
			}
			if(dir == 'right' ){
				$arrowR.addClass('hide');				
				$("body.path-values .awards").removeClass("value-left");
			}else{
				$arrowR.removeClass('hide');
				$arrowL.removeClass('hide');
			}
			
		}else{
		
			if (dir == 'left' && thumbLeft < Math.abs(scrollSpace) ) {
			
				$arrowL.addClass('hide');
			} else {
				$arrowL.removeClass('hide');
			}

			if(dir == 'right' && (thumbRight + scrollSpace) <= windowW) {
				$arrowR.addClass('hide');
			} else {
				$arrowR.removeClass('hide');
			}
			
		}
		trace.push('initialcounter'+initialcounter);
		trace.push('arrowCounter'+arrowCounter);
		trace.push('allData'+allData);
		//if (dir == 'left' && thumbLeft < Math.abs(scrollSpace) ) {
		/**if (dir == 'left'&& !firstSlide) {
			$arrowL.addClass('hide');
		} else {
			$arrowL.removeClass('hide');
		}

		if(dir == 'right' && (thumbRight + scrollSpace) <= windowW) {
			$arrowR.addClass('hide');
		} else {
			$arrowR.removeClass('hide');
		}**/
		
	}


	$(function(){
		init();
	});
	})(jQuery);
})(window.site=window.site || {}, jQuery);
